/**
 * React hook for comment like state.
 *
 * Reactive read from SecureStorage — mirrors useUserMediaLike. Updates
 * automatically when any component toggles the like via likeCommentUseCase
 * (which writes to the same storage key).
 */

import { useListenToSecureStorageUpdates } from '@/data/storage/local/secureStorageWebCrypto';
import { SECURE_STORAGE_KEYS } from '@/domain/entities/secureStorage/secureStorageKeys';
import type { CommentLikeStorage } from '@/domain/entities/secureStorage/secureStorageEntities';

export function useCommentLike(commentId: string) {
  const storageKey = SECURE_STORAGE_KEYS.COMMENT_LIKES + commentId;
  const { data, loading } = useListenToSecureStorageUpdates<CommentLikeStorage>(storageKey);

  return {
    likeData: data,
    isLiked: data?.liked ?? false,
    loading,
  };
}
